import { useState, useCallback, useMemo } from 'react';
import { SortConfig, getNextSortDirection, sortData } from '../utils/tableSorting';

export const useTableSort = <T>(
  initialData: T[],
  getValue: (item: T, key: string) => any
) => {
  const [sortConfig, setSortConfig] = useState<SortConfig>({
    key: '',
    direction: 'none'
  });

  const handleSort = useCallback((key: string) => {
    setSortConfig(prevConfig => {
      const newDirection = prevConfig.key === key ? getNextSortDirection(prevConfig.direction) : 'asc';
      console.log('Sorting:', { key, prevDirection: prevConfig.direction, newDirection });
      return {
        key,
        direction: newDirection
      };
    });
  }, []);

  // Use useMemo to ensure proper sorting and avoid unnecessary re-sorts
  const sortedData = useMemo(() => {
    return sortData(initialData, sortConfig, getValue);
  }, [initialData, sortConfig, getValue]);

  return {
    sortConfig,
    handleSort,
    sortedData
  };
};

export const useTableSort2 = () => {
  const [sortConfig, setSortConfig] = useState<SortConfig>({
    key: '',
    direction: 'none'
  });

  const handleSort = useCallback((key: string) => {
    setSortConfig(prevConfig => {
      const newDirection = prevConfig.key === key ? getNextSortDirection(prevConfig.direction) : 'asc';
      //console.log('Sorting:', { key, prevDirection: prevConfig.direction, newDirection });
      return {
        key,
        direction: newDirection
      };
    });
  }, []);

  return {
    sortConfig,
    handleSort
  };
};
